import Footer from "../../components/Footer/Footer";
import NavBar from "../../components/NavBar/NavBar";
import Title from "../../components/Title/Title";
import '../../styles/Source-Link.css';
import CustomButton from "../../components/Custom-Button/CustomButton";
import Download from "../../components/Download-Button/Download-button";
export default function Commandment() {

    return (
        <div>
            <NavBar/>
            <Title text={"Sobre os 10 Mandamentos"}/>

            <p className="info-text">
                Os Dez Mandamentos, dados por Deus a Moisés, são preceitos fundamentais para a vida moral cristã[1][2]. 
                O Catecismo da Igreja Católica (CIC) os explica como exigências do amor a Deus e ao próximo. <br/>
                Os três primeiros referem-se ao amor de Deus; os sete restantes, ao amor ao próximo[3][4]. <br/> 
                A seguir, examinamos cada mandamento: apresentando sua formulação tradicional, explicando seu sentido no CIC (citando-o quando possível), mostrando aplicações práticas e ressaltando aspectos teológicos essenciais.
            </p> 

            <Title text={"Explicações Sobre Cada Um e suas Aplicações no Cotidiano"}/>
            <div className="btn-row">
                <CustomButton text={"Primeiro Mandamento"} route={"/MD-1"}/> 
                <CustomButton text={"Segundo Mandamento"} route={"/MD-2"}/>                 
                <CustomButton text={"Terceiro Mandamento"} route={"/MD-3"}/>                
                <CustomButton text={"Quarto Mandamento"} route={"/MD-4"}/>                
                <CustomButton text={"Quinto Mandamento"} route={"/MD-5"}/>                
                <CustomButton text={"Sexto Mandamento"} route={"/MD-6"}/>                
                <CustomButton text={"Sétimo Mandamento"} route={"/MD-7"}/>
                <CustomButton text={"Oitavo Mandamento"} route={"/MD-8"}/>                
                <CustomButton text={"Nono Mandamento"} route={"/MD-9"}/>                
                <CustomButton text={"Décimo Mandamento"} route={"/MD-10"}/>
                <Download text={"Baixar Fontes Utilizadas"} File={"https://nsykpvjwslvdnfbknhmm.supabase.co/storage/v1/object/public/church/Downloadable_Files/Fontes_Mandamentos.docx"}/>
                </div> 
            <Footer/>
        </div>
    )
}